export let RoutePath = /*#__PURE__*/function (RoutePath) {
  RoutePath["Login"] = "/";
  RoutePath["LdapLogin"] = "/ldap";
  RoutePath["TwoFactorApp"] = "/2fa-app";
  RoutePath["TwoFactorAppSetup"] = "/2fa-app-setup";
  RoutePath["TwoFactorChoice"] = "/2fa-choice";
  RoutePath["TwoFactorTelegram"] = "/2fa-telegram";
  RoutePath["TwoFactorTelegramSetup"] = "/2fa-telegram/setup";
  RoutePath["TwoFactorPhoneIndex"] = "/2fa-phone";
  RoutePath["TwoFactorSMS"] = "/2fa-phone/sms";
  RoutePath["TwoFactorNoPhone"] = "/2fa-phone/no-phone";
  RoutePath["ProtectionWayChoice"] = "/protection-choice";
  RoutePath["PasskeyRegister"] = "/passkey/register";
  RoutePath["PasskeyLogin"] = "/passkey";
  RoutePath["PasskeyConfigure"] = "/passkey/configure";
  RoutePath["PasskeyConfigureRegister"] = "/passkey/configure/register";
  RoutePath["PersonalData"] = "/personal-data";
  RoutePath["CheckIdentity"] = "/check-identity";
  RoutePath["Terms"] = "/terms";
  RoutePath["Recovery"] = "/recovery";
  RoutePath["SetPassword"] = "/set-password";
  RoutePath["ConfirmEmail"] = "/confirm-email";
  RoutePath["ConfigureEmail"] = "/configure-email";
  RoutePath["ConfirmIdpSubUpdate"] = "/confirm-idp-sub-update";
  RoutePath["ConfirmIdentityMerge"] = "/confirm-identity-merge";
  RoutePath["Consents"] = "/consents";
  RoutePath["LoginMethods"] = "/login-methods";
  RoutePath["BrokenLink"] = "/broken-link";
  RoutePath["ErrorPage"] = "/error-page";
  RoutePath["AppErrorPage"] = "/app-error-page";
  RoutePath["MagicLink"] = "/magic-link";
  RoutePath["OpenExternalApp"] = "/open-external-app";
  return RoutePath;
}({});